import { type FunctionComponent } from 'react';

const BANNER_STYLE_MAP = {
	ferguson: 'bg-theme-primary-lighter theme-primary',
	success: 'bg-theme-success-light theme-success',
	alert: 'bg-theme-warning-light theme-warning',
	error: 'bg-theme-error-light theme-error'
};

export type TextBannerProps = {
	text: string;
	style: keyof typeof BANNER_STYLE_MAP;
	icon?: React.ReactNode;
	className?: string;
};

export const TextBanner: FunctionComponent<TextBannerProps> = ({ text, style, icon, className = '' }) => (
	<div className={className}>
		<div className={`flex items-center pa1 br2 f7 b lh-title ${BANNER_STYLE_MAP[style]}`}>
			{icon}
			{text}
		</div>
	</div>
);
